import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { arrayMove } from 'react-sortable-hoc';
import { Row, Col } from 'antd';
import notebookItemStyle from '../../components/NotebookList/NotebookItem/NotebookItem.scss';

// actions
import { getNotebooks, sortNotebooks } from '../../actions/NotebooksAction';
import { getState } from '../../reducers/Notebooks/NotebooksReducer';

// container
import NotesContainer from '../NotesContainer/NotesContainer';

// component
import NotebooksWrapper from '../../components/NotebooksWrapper/NotebooksWrapper';

@connect(
  state => ({
    notebooks: getState(state),
  }),
  dispatch => ({
    getNotebooks: () => dispatch(getNotebooks()),
    sortNotebooks: (oldSeq, newSeq) => dispatch(sortNotebooks(oldSeq, newSeq)),
  }),
)
export default class NotebooksContainer extends Component {
  sortNotebooks = ({ oldIndex, newIndex }) => {
    // 只有顺序变了，才触发action
    if (oldIndex !== newIndex) {
      const oldSeq = this.props.notebooks.get('seq').toJS();
      const newSeq = arrayMove(oldSeq, oldIndex, newIndex);
      this.props.sortNotebooks(oldSeq, newSeq);
    }
  };

  hideDropDown = (e) => {
    if (document.body.click) {
      document.body.click(); // hidden the DropDown
    }
    const disabledElements = ['input', 'textarea', 'select', 'option', 'button'];
    return disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1;
  };

  render() {
    const { match } = this.props;
    return (
      <Fragment>
        <NotebooksWrapper
          distance={1}
          helperClass={notebookItemStyle['notebook-item-dragging']}
          onSortEnd={this.sortNotebooks}
          shouldCancelStart={this.hideDropDown}
        />
        <Col style={{ height: '100%' }} span={20}>
          <Route path={match.path} component={NotesContainer}/>
        </Col>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotebooksContainer/NotebooksContainer.js